import { render, staticRenderFns } from "./HomeMain.vue?vue&type=template&id=4f3a0126&scoped=true&"
import script from "./HomeMain.vue?vue&type=script&lang=js&"
export * from "./HomeMain.vue?vue&type=script&lang=js&"
import style0 from "./HomeMain.vue?vue&type=style&index=0&id=4f3a0126&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3a0126",
  null
  
)

export default component.exports